import styled from 'styled-components'
import { Svg360Interior } from '../../components/SvgImports'
import { TextId, useTextsV2 } from '../../utils/useTexts'
import { TdsChip } from '@scania/tegel-react'

const Interior360IconRoot = styled(TdsChip)`
  svg {
    height: 20px;
    width: 20px;
  }
`

const TextWrapper = styled.div`
  margin-right: 4px;
`

export const Interior360Icon = (): JSX.Element => {
  const t2 = useTextsV2()

  return (
    <Interior360IconRoot size="sm">
      <span slot="label">
        <TextWrapper>360 {t2(TextId.LABEL_VIEW_INTERIOR)}</TextWrapper>
        <Svg360Interior />
      </span>
    </Interior360IconRoot>
  )
}
